import { useState } from "react";
import { UtensilsCrossed } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * SmartImage: shows an owner-uploaded photo for the given slot when available,
 * otherwise renders a clean, on-brand placeholder block (no upload prompt on the
 * public site). `hasImage` comes from the app-level slot set to avoid 404 spam.
 */
export const SmartImage = ({ slot, hasImage, alt = "", className = "", imgClassName = "" }) => {
  const [errored, setErrored] = useState(false);
  const available = hasImage && !errored;
  const src = `${API}/images/${slot}`;

  if (available) {
    return (
      <img
        src={src}
        alt={alt}
        data-testid={`img-${slot}`}
        onError={() => setErrored(true)}
        className={imgClassName || className}
        loading="lazy"
      />
    );
  }

  return (
    <div
      data-testid={`placeholder-${slot}`}
      className={`flex flex-col items-center justify-center bg-gradient-to-br from-[#151515] to-[#0C0C0C] text-neutral-600 select-none ${className}`}
    >
      <UtensilsCrossed size={26} className="text-gold/30 mb-2" />
      <span className="font-serif-q5 text-2xl text-gold/40 leading-none">Q5</span>
    </div>
  );
};
